import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 152625 161030"
    {...props}
  >
    <path
      d="M54820 134487 29420 33621v109272c0 6044-1365 10579-4056 13602-2691 3024-6268 4535-10690 4535-4314 0-7855-1511-10582-4499C1365 153547 0 149012 0 142893V17623C0 10690 1808 6047 5382 3613 8995 1216 13863 0 19946 0h9953c5972 0 10286 554 12977 1622 2691 1069 4718 3024 6008 5826s2766 7373 4424 13713l23006 86782 23002-86782c1659-6340 3134-10911 4424-13713 1291-2802 3281-4757 5973-5826C112404 554 116753 0 122726 0h9917c6119 0 10986 1216 14599 3613 3577 2434 5383 7077 5383 14010v125270c0 6044-1365 10579-4056 13602-2692 3024-6305 4535-10801 4535-4239 0-7742-1511-10471-4535-2728-3023-4092-7558-4092-13602V33621L97804 134487c-1658 6526-2984 11354-4053 14414-1033 3023-2951 5825-5753 8331-2838 2544-6709 3798-11684 3798-3763 0-6933-811-9513-2433-2581-1623-4608-3688-6045-6194-1439-2544-2583-5308-3391-8369-850-3060-1698-6266-2545-9547z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
